import classNames from "classnames";
import { ForwardedRef, forwardRef, memo, ReactNode } from "react";
import { Flex } from "../../flex";
import * as redoButtonCss from "./redo-button.module.css";

/**
 * @param children -- this should be a list of RedoButtons
 */
export interface RedoButtonGroupProps {
  children: ReactNode;
  squared?: boolean;
  "data-arbiter"?: string;
}

export const RedoButtonGroup = memo(
  forwardRef(function RedoButtonDropdown(
    {
      children,
      squared,
      "data-arbiter": dataArbiter = "RedoButtonGroup",
    }: RedoButtonGroupProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) {
    return (
      <Flex
        className={classNames(redoButtonCss.buttonGroup, {
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          [redoButtonCss.squared]: squared,
        })}
        data-arbiter={dataArbiter}
        gap="none"
        ref={ref}
      >
        {children}
      </Flex>
    );
  }),
);
